<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <path d="M8.5 6.75C8.5 6.33579 8.16421 6 7.75 6C7.33579 6 7 6.33579 7 6.75V14.25C7 14.6642 7.33579 15 7.75 15C8.16421 15 8.5 14.6642 8.5 14.25V6.75ZM13 6.75C13 6.33579 12.6642 6 12.25 6C11.8358 6 11.5 6.33579 11.5 6.75V14.25C11.5 14.6642 11.8358 15 12.25 15C12.6642 15 13 14.6642 13 14.25V6.75ZM10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5ZM1.5 10.5C1.5 5.80558 5.30558 2 10 2C14.6944 2 18.5 5.80558 18.5 10.5C18.5 15.1944 14.6944 19 10 19C5.30558 19 1.5 15.1944 1.5 10.5Z" />
  </svg>
</template>
